// Utility for saving and loading sender selections to/from disk
class FileStorage {
  constructor() {
    this.STORAGE_KEY = 'gmail_helper_selections';
  }

  // Save selections to a JSON file
  saveSelections(selectedSenders, allSenders) {
    const data = {
      version: '1.0',
      timestamp: new Date().toISOString(),
      selectedSenders: Array.from(selectedSenders),
      senderMetadata: allSenders.reduce((acc, sender) => {
        acc[sender.email] = {
          displayName: sender.displayName,
          count: sender.count
        };
        return acc;
      }, {})
    };

    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'gmail-sender-selections.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // Also save to localStorage as backup
    localStorage.setItem(this.STORAGE_KEY, jsonString);
  }

  // Load selections from a file
  async loadSelectionsFromFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = JSON.parse(e.target.result);
          resolve({
            selectedSenders: new Set(data.selectedSenders || []),
            senderMetadata: data.senderMetadata || {},
            timestamp: data.timestamp
          });
        } catch (error) {
          reject(new Error('Invalid file format'));
        }
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsText(file);
    });
  }

  // Load from localStorage
  loadFromLocalStorage() {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (!stored) return null;

      const data = JSON.parse(stored);
      return {
        selectedSenders: new Set(data.selectedSenders || []),
        senderMetadata: data.senderMetadata || {},
        timestamp: data.timestamp
      };
    } catch (error) {
      console.error('Failed to load from localStorage:', error);
      return null;
    }
  }

  // Clear stored data
  clearStorage() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

export default new FileStorage();
